import DataTablePage from 'components/DataTablePage';
import MDButton from 'components/MDButton';
import { Navigate, useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogActions } from '@mui/material';
import { Can } from 'context';
import { useState } from 'react';
import clientColumnData from 'data/clientColumnData';
import { deleteClient, getClients } from 'services/clients';
import usePersistedFilters from 'hooks/usePersistedFilters';

function ClientManagement() {
  const navigate = useNavigate();
  const { setEntityFiltersForNavigation } = usePersistedFilters();
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const [deleteClientId, setDeleteClientId] = useState('');
  const [filters, setFilters] = useState({});

  const handleViewDashboard = (client) => {
    setEntityFiltersForNavigation({
      clientIds: [client.id],
      clientNames: [client.name]
    });
    navigate('/dashboard');
  };

  return (
    <>
      <Can I='read' a='client'>
        <DataTablePage
          title='Integration Management'
          createButton={
            <Can I='create' a='client'>
              <MDButton variant='contained' color='info' onClick={() => navigate('/client-management/new-client')}>
                Add Integration
              </MDButton>
            </Can>
          }
          canSearch
          canFilter
          fetchData={getClients}
          queryKey='clients'
          columnData={clientColumnData}
          object={'client'}
          onDelete={(id) => {
            setDeleteClientId(id);
            handleOpenModal();
          }}
          onView={handleViewDashboard}
          filters={filters}
        />
        <Dialog
          open={showModal}
          onClose={handleCloseModal}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{'Are you sure you want to delete this integration?'}</DialogTitle>
          <DialogActions>
            <MDButton
              onClick={async () => {
                await deleteClient(deleteClientId);
                handleCloseModal();
                setFilters((prev) => ({ ...prev, _refresh: Date.now() }));
              }}
            >
              Yes
            </MDButton>
            <MDButton onClick={handleCloseModal}>No</MDButton>
          </DialogActions>
        </Dialog>
      </Can>
      <Can not I='read' a='client'>
        <Navigate to='/dashboard' replace />
      </Can>
    </>
  );
}

export default ClientManagement;
